import { render, staticRenderFns } from "./ShareList.vue?vue&type=template&id=73b7a1c1&scoped=true&"
import script from "./ShareList.vue?vue&type=script&lang=js&"
export * from "./ShareList.vue?vue&type=script&lang=js&"
import style0 from "./ShareList.vue?vue&type=style&index=0&id=73b7a1c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b7a1c1",
  null
  
)

export default component.exports